// extracted by mini-css-extract-plugin
module.exports = {"a":"index_a___xAxF","logoImg":"index_logoImg__sRFkG","logo":"index_logo__1QfLp","darkLogo":"index_darkLogo__n2mYe"};